module.exports = __webpack_public_path__ + "static/media/jovan.0f14209c.jpg";